import {I18n} from "../LangUtil";
const BHR = {
  getIdOpts(){
    return {
      label: I18n("g.lbl.cprid"),
      sizeRange: [9,9]
    }
  },
  getTenantInfo(){
    return {
      name: "Modern Exchange"
    }
  },
  getMessages(){
    return {
      blackListedMsg: I18n('g.msg.blacklistedcustbhr'),
      additionalRemittanceThxText: I18n('g.lbl.addthx')
    }
  },
  getSupportInfo(){
    return {
      custPhone: DataStore.getData().customerCareDetails.custPhone,
      custEmail: DataStore.getData().customerCareDetails.custEmail,
      time: DataStore.getData().customerCareDetails.time
    }
  },
  getThankyouText(){
    return "Thank you for choosing Modern Exchange";
  }
};

export default BHR;
